import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IdentityBrokeringPolicyDto } from '../interfaces/identity-brokering-policy-dto';
import { PaginatedSearchResponse } from '../interfaces/paginated-search-response';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class SingleSignOnServiceService {
    private readonly http = inject(HttpClient);
    private env = inject(envToken);

    getIdpUrl = '';
    saveIdpUrl = '';
    ssoUserDetailsSearchUrl = '';

    constructor() {
        this.getIdpUrl = this.env.apiUrl + '/api/v1/identity-brokering-policy/enterprise/';
        this.saveIdpUrl = this.env.apiUrl + '/api/v1/policy/identity-brokering/enterprise/';
        this.ssoUserDetailsSearchUrl = this.env.apiUrl + '/api/v1/sso-user-details/search';
    }

    getIdentityBrokeringPolicy(enterpriseId: number): Observable<IdentityBrokeringPolicyDto> {
        return this.http.get<IdentityBrokeringPolicyDto>(`${this.getIdpUrl}${enterpriseId}`);
    }

    saveIdentityBrokeringPolicy(enterpriseId: number, identityBrokeringPolicy: IdentityBrokeringPolicyDto) {
        return this.http.post(`${this.saveIdpUrl}${enterpriseId}`, identityBrokeringPolicy);
    }

    hasMissingEmail(enterpriseId: number): Observable<boolean> {
        return this.http.get<PaginatedSearchResponse<unknown>>(this.ssoUserDetailsSearchUrl, {
            params: { enterpriseId, enabled: true, hasEmail: false, page: 0, size: 1 }
        }).pipe(map(response => response.totalElements > 0));
    }

    hasMissingDateOfBirth(enterpriseId: number): Observable<boolean> {
        return this.http.get<PaginatedSearchResponse<unknown>>(this.ssoUserDetailsSearchUrl, {
            params: { enterpriseId, enabled: true, hasDob: false, page: 0, size: 1 }
        }).pipe(map(response => response.totalElements > 0));
    }
}
